import { isNull, isUndefined } from 'lodash';

export const fireTrackingEvent = (cb = false, eventName) => {
  const isIntercomBooted = localStorage.getItem('is-intercom-booted');
  // need to be explicit with this error handling because of browser compatibility and for testing purposes in the future
  if (cb !== false) {
    cb(eventName);
  }
  if (
    isNull(isIntercomBooted) ||
    isUndefined(isIntercomBooted) ||
    isIntercomBooted === 'false'
  ) {
    return;
  }
  window.Intercom('trackEvent', eventName);
};
